import { render, staticRenderFns } from "./SpecialtyColorCostCalculator.vue?vue&type=template&id=48ac4ee7&scoped=true&"
import script from "./SpecialtyColorCostCalculator.vue?vue&type=script&lang=js&"
export * from "./SpecialtyColorCostCalculator.vue?vue&type=script&lang=js&"
import style0 from "./SpecialtyColorCostCalculator.vue?vue&type=style&index=0&id=48ac4ee7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ac4ee7",
  null
  
)

export default component.exports